module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-translation-add"
  }, [(Object.keys(_vm.translations).length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column large-4"
  }, [_vm._t("default"), (_vm.translations !== []) ? _c('ul', {
    directives: [{
      name: "f-accordion",
      rawName: "v-f-accordion"
    }],
    staticClass: "accordion",
    attrs: {
      "data-accordion": "",
      "data-allow-all-closed": "true"
    }
  }, _vm._l((_vm.translations), function(values, group) {
    return _c('li', {
      staticClass: "accordion-item",
      attrs: {
        "data-accordion-item": ""
      }
    }, [_c('a', {
      staticClass: "accordion-title",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(group.toUpperCase()))]), _c('div', {
      staticClass: "accordion-content",
      attrs: {
        "data-tab-content": ""
      }
    }, _vm._l((values), function(value) {
      return _c('div', [_c('a', {
        staticClass: "small",
        on: {
          "click": function($event) {
            return _vm.openEditor(value.key, group)
          }
        }
      }, [_vm._v(_vm._s(value.key))])])
    }), 0)])
  }), 0) : _vm._e()], 2), (Object.keys(_vm.selected).length) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "card p-2"
  }, [_c('span', {
    staticClass: "fa fa-times text-right",
    on: {
      "click": function($event) {
        _vm.selected = {}
      }
    }
  }), _c('TranslationEdit', {
    attrs: {
      "item": _vm.selected,
      "delete-button": _vm.selected.id !== undefined
    }
  })], 1)]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b7a9fc0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/GroupedTranslation.vue
// module id = 2604
// module chunks = 1